/* ======================================================================
   Robusta Coins — interface na loja
   Fala com o App Proxy do app (/apps/robusta-coins). Nenhuma regra de
   negócio mora aqui: o app é a fonte da verdade, o tema só desenha.
====================================================================== */
(function () {
  'use strict';

  function brl(cents) {
    return 'R$ ' + (Number(cents || 0) / 100).toFixed(2).replace('.', ',');
  }

  function api(proxy, path, options) {
    return fetch(proxy + path, Object.assign({ headers: { 'Accept': 'application/json' } }, options))
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); });
  }

  /* ============================================================
     A. Formulário de avaliação com escada de coins
  ============================================================ */
  function initReviewForm(root) {
    var proxy = root.getAttribute('data-proxy') || '/apps/robusta-coins';
    var form = root.querySelector('[data-coins-form]');
    var gate = root.querySelector('[data-coins-gate]');
    if (!form) return;

    var state = { rating: 0, text: '', photos: [], video: null, videoSeconds: 0 };
    var regras = null;

    var starsWrap = root.querySelector('[data-coins-stars]');
    var textEl = root.querySelector('[data-coins-text]');
    var charsEl = root.querySelector('[data-coins-chars]');
    var totalEl = root.querySelector('[data-coins-total]');
    var moneyEl = root.querySelector('[data-coins-money]');
    var fillEl = root.querySelector('[data-coins-fill]');
    var hintEl = root.querySelector('[data-coins-hint]');
    var msgEl = root.querySelector('[data-coins-msg]');
    var submitBtn = root.querySelector('[data-coins-submit]');

    /* ── Quem pode avaliar ──
       O formulário nasce fechado e só abre para quem comprou, recebeu e ainda
       está na janela. Antes ele aparecia para qualquer visitante e a recusa só
       vinha no envio — a pessoa escrevia à toa. O pedido também vem daqui: a
       página não tem como saber em qual compra a avaliação se apoia. */
    var pedido = '';
    form.setAttribute('hidden', 'hidden');

    /* As regras da escada não dependem de quem está olhando: buscá-las antes
       de tudo faz os valores de cada degrau aparecerem já no primeiro quadro,
       inclusive para quem ainda não entrou na conta. É o convite. */
    api(proxy, '/regras').then(function (res) {
      regras = res.data || null;
      atualizar();
    });

    function bloquear(html) {
      form.setAttribute('hidden', 'hidden');
      if (!gate) return;
      gate.removeAttribute('hidden');
      gate.innerHTML = html;
    }

    /* Na área do cliente a lista já foi montada a partir de compras entregues:
       refazer a checagem aqui só repetiria trabalho e atrasaria a tela. Quem
       abre o formulário informa produto e pedido. */
    if (root.hasAttribute('data-coins-manual')) {
      root.abrirPara = function (item) {
        pedido = item.pedidoId || '';
        root.setAttribute('data-product-id', item.produtoId || '');
        root.setAttribute('data-product-title', item.titulo || '');
        var tit = root.querySelector('[data-coins-form-titulo]');
        if (tit) tit.textContent = 'Avaliar ' + (item.titulo || 'produto');
        if (gate) gate.setAttribute('hidden', 'hidden');
        form.removeAttribute('hidden');
        // Zera o que sobrou de uma avaliação anterior na mesma sessão.
        state = { rating: 0, text: '', photos: [], video: null, videoSeconds: 0 };
        form.reset();
        root.querySelectorAll('.coins-star').forEach(function (b) {
          b.classList.remove('is-on'); b.setAttribute('aria-checked', 'false');
        });
        root.querySelectorAll('[data-coins-photo-previews],[data-coins-video-preview]')
            .forEach(function (el) { el.innerHTML = ''; });
        var chars = root.querySelector('[data-coins-chars]');
        if (chars) chars.textContent = '0';
        atualizar();
      };
      return;
    }

    api(proxy, '/elegibilidade?produto=' + encodeURIComponent(root.getAttribute('data-product-id') || ''))
      .then(function (res) {
        var d = (res && res.data) || {};

        if (d.logado === false) {
          bloquear(
            '<p>Entre na sua conta para avaliar e ganhar Robusta Coins.</p>' +
            '<a class="coins-submit coins-submit--ghost" href="/account/login">Entrar na minha conta</a>');
          return;
        }

        if (!d.podeAvaliar) {
          var extra = d.codigo === 'nao_comprou'
            ? '<a class="coins-submit coins-submit--ghost" href="#comprar">Ver o produto</a>' : '';
          bloquear('<p>' + (d.mensagem || 'Esta avaliação não está disponível para você agora.') + '</p>' + extra);
          return;
        }

        pedido = d.orderId || '';
        if (gate) gate.setAttribute('hidden', 'hidden');
        form.removeAttribute('hidden');

        atualizar();
      })
      .catch(function () {
        bloquear('<p>Não foi possível verificar sua compra agora. Recarregue a página para tentar de novo.</p>');
      });

    /* ── Estrelas ── */
    if (starsWrap) {
      starsWrap.querySelectorAll('.coins-star').forEach(function (btn) {
        btn.addEventListener('click', function () {
          state.rating = parseInt(btn.getAttribute('data-value'), 10) || 0;
          starsWrap.querySelectorAll('.coins-star').forEach(function (b, i) {
            var on = i < state.rating;
            b.classList.toggle('is-on', on);
            b.setAttribute('aria-checked', String(i === state.rating - 1));
          });
          atualizar();
        });
      });
    }

    /* ── Texto ── */
    if (textEl) {
      textEl.addEventListener('input', function () {
        state.text = textEl.value;
        if (charsEl) charsEl.textContent = state.text.trim().length;
        atualizar();
      });
    }

    /* ── Título (não pontua, mas mantém a prévia viva enquanto se digita) ── */
    var tituloEl = root.querySelector('[data-coins-titulo]');
    if (tituloEl) tituloEl.addEventListener('input', atualizar);

    /* ── Fotos ── */
    var photosInput = root.querySelector('[data-coins-photos]');
    var photoPreviews = root.querySelector('[data-coins-photo-previews]');
    if (photosInput) {
      photosInput.addEventListener('change', function () {
        state.photos = Array.prototype.slice.call(photosInput.files || []);
        if (photoPreviews) {
          photoPreviews.innerHTML = '';
          state.photos.forEach(function (file) {
            var img = document.createElement('img');
            img.className = 'coins-preview';
            img.src = URL.createObjectURL(file);
            img.alt = '';
            photoPreviews.appendChild(img);
          });
        }
        atualizar();
      });
    }

    /* ── Vídeo (lê a duração antes de pontuar) ── */
    var videoInput = root.querySelector('[data-coins-video]');
    var videoPreview = root.querySelector('[data-coins-video-preview]');
    if (videoInput) {
      videoInput.addEventListener('change', function () {
        var file = (videoInput.files || [])[0];
        state.video = file || null;
        state.videoSeconds = 0;
        if (videoPreview) videoPreview.innerHTML = '';
        if (!file) { atualizar(); return; }

        var url = URL.createObjectURL(file);
        var v = document.createElement('video');
        v.className = 'coins-preview coins-preview--video';
        v.src = url;
        v.controls = true;
        v.preload = 'metadata';
        v.addEventListener('loadedmetadata', function () {
          state.videoSeconds = Math.floor(v.duration || 0);
          atualizar();
        });
        if (videoPreview) videoPreview.appendChild(v);
      });
    }

    /* ── Prévia da pontuação ──
       O cálculo roda no navegador, a cada tecla, a partir das regras que o app
       entrega uma única vez. Antes cada caractere digitado disparava uma ida ao
       servidor com 220ms de espera: o número chegava atrasado e não parecia
       reagir ao que a pessoa fazia. A recompensa só motiva se ela vê subir. */
    function atualizar() { atualizarPrevia(); }

    var exibido = 0;   // valor atualmente na tela, para animar a diferença
    var animar = null;

    function pintarTotal(alvo) {
      if (!totalEl) return;
      cancelAnimationFrame(animar);
      var inicio = exibido, delta = alvo - inicio, t0 = null;
      var reduzir = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!delta || reduzir) { exibido = alvo; totalEl.textContent = alvo; return; }
      (function passo(t) {
        if (t0 === null) t0 = t;
        var k = Math.min((t - t0) / 420, 1);
        var suave = 1 - Math.pow(1 - k, 3);
        exibido = Math.round(inicio + delta * suave);
        totalEl.textContent = exibido;
        if (k < 1) animar = requestAnimationFrame(passo);
      })(performance.now());
    }

    /* Espelha a escada do app: cada degrau exige o anterior. */
    function calcularLocal() {
      if (!regras) return null;
      var e = regras.etapas || {};
      var etapas = [], coins = 0, faltando = [];

      var temNota  = state.rating > 0;
      var temTexto = (state.text || '').trim().length >= (regras.minCaracteres || 120);
      var temFoto  = state.photos.length > 0;
      var temVideo = !!state.video && state.videoSeconds >= (regras.minSegundosVideo || 15);

      if (temNota) { etapas.push('rating'); coins += e.rating || 0; }
      else faltando.push({ etapa: 'rating', coins: e.rating || 0, motivo: 'dê sua nota em estrelas' });

      if (temNota && temTexto) { etapas.push('text'); coins += e.text || 0; }
      else if (temNota) {
        var faltam = (regras.minCaracteres || 120) - (state.text || '').trim().length;
        faltando.push({ etapa: 'text', coins: e.text || 0,
          motivo: 'escreva mais ' + faltam + ' caractere' + (faltam > 1 ? 's' : '') });
      }

      if (temNota && temTexto && temFoto) { etapas.push('photo'); coins += e.photo || 0; }
      else if (temNota && temTexto) faltando.push({ etapa: 'photo', coins: e.photo || 0, motivo: 'adicione uma foto' });

      if (temNota && temTexto && temFoto && temVideo) { etapas.push('video'); coins += e.video || 0; }
      else if (temNota && temTexto && temFoto) {
        faltando.push({ etapa: 'video', coins: e.video || 0,
          motivo: 'grave um vídeo de ' + (regras.minSegundosVideo || 15) + 's ou mais' });
      }

      return { coins: coins, etapas: etapas, faltando: faltando,
               centavos: coins * (regras.valorMoedaCentavos || 5) };
    }

    function atualizarPrevia() {
      var d = calcularLocal();
      if (!d) return;

      pintarTotal(d.coins);
      if (moneyEl) moneyEl.textContent = brl(d.centavos);

      root.querySelectorAll('.coins-ladder__step').forEach(function (li) {
        var etapa = li.getAttribute('data-step');
        li.classList.toggle('is-done', d.etapas.indexOf(etapa) !== -1);
        var el = li.querySelector('[data-step-coins]');
        if (el && regras && regras.etapas) el.textContent = '+' + (regras.etapas[etapa] || 0);
      });

      if (fillEl) fillEl.style.width = ((d.etapas.length / 4) * 100) + '%';

      if (hintEl) {
        var prox = d.faltando[0];
        hintEl.textContent = prox
          ? 'Faltam ' + prox.coins + ' coins: ' + prox.motivo
          : 'Você destravou todas as etapas. Máximo de coins nesta avaliação.';
      }
    }


    /* ── Envio ── */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!state.rating) {
        mostrar('Dê pelo menos uma nota em estrelas.', 'erro');
        return;
      }

      submitBtn.disabled = true;
      submitBtn.classList.add('is-loading');

      // As mídias sobem primeiro para o storage; aqui vão as URLs resultantes.
      uploadMidias().then(function (midias) {
        return api(proxy, '/avaliacao', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            productId: root.getAttribute('data-product-id'),
            productTitle: root.getAttribute('data-product-title'),
            orderId: pedido,
            rating: state.rating,
            text: state.text,
            titulo: (root.querySelector('[data-coins-titulo]') || {}).value || '',
            photoUrls: midias.photoUrls,
            photoHashes: midias.photoHashes,
            videoUrl: midias.videoUrl,
            videoHash: midias.videoHash,
            videoSeconds: state.videoSeconds,
          }),
        });
      }).then(function (res) {
        submitBtn.disabled = false;
        submitBtn.classList.remove('is-loading');
        var d = res.data || {};
        if (!res.ok) {
          mostrar(d.mensagem || 'Não foi possível enviar sua avaliação.', 'erro');
          return;
        }
        form.setAttribute('hidden', 'hidden');
        if (gate) {
          gate.removeAttribute('hidden');
          gate.innerHTML =
            '<div class="coins-sucesso">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>' +
            '<p>' + (d.mensagem || 'Avaliação enviada!') + '</p>' +
            '</div>';
        }
      }).catch(function () {
        submitBtn.disabled = false;
        submitBtn.classList.remove('is-loading');
        mostrar('Erro de conexão. Tente novamente.', 'erro');
      });
    });

    /**
     * Upload das mídias para o Shopify Files via App Proxy.
     * O app devolve a URL do CDN e o hash SHA-256 dos bytes — é o hash que
     * alimenta a checagem de duplicidade.
     */
    function uploadMidias() {
      var vazio = { photoUrls: [], photoHashes: [], videoUrl: null, videoHash: null };
      if (!state.photos.length && !state.video) return Promise.resolve(vazio);
      var fd = new FormData();
      state.photos.forEach(function (f) { fd.append('fotos', f); });
      if (state.video) fd.append('video', state.video);

      return fetch(proxy + '/upload', { method: 'POST', body: fd })
        .then(function (r) { return r.json().then(function (d) {
          if (!r.ok) throw new Error(d.mensagem || 'Falha ao enviar os arquivos.');
          return d;
        }); });
    }

    function mostrar(texto, estado) {
      if (!msgEl) return;
      msgEl.textContent = texto;
      msgEl.setAttribute('data-state', estado);
      msgEl.removeAttribute('hidden');
    }
  }

  document.querySelectorAll('[data-coins-review]').forEach(initReviewForm);


  /* ============================================================
     B. Saldo na conta do cliente
  ============================================================ */
  function initBalance(root) {
    var proxy = root.getAttribute('data-proxy') || '/apps/robusta-coins';

    api(proxy, '/saldo').then(function (res) {
      var d = res.data || {};
      if (d.logado === false) {
        root.innerHTML = '<a class="coins-submit coins-submit--ghost" href="/account/login">Entre para ver seus coins</a>';
        return;
      }

      var extrato = (d.extrato || []).map(function (e) {
        var sinal = e.coins > 0 ? '+' : '';
        var rotulo = e.status === 'PENDING' ? ' (pendente)' : e.status === 'EXPIRED' ? ' (expirado)' : '';
        return '<li class="coins-extrato__item' + (e.coins < 0 ? ' is-debit' : '') + '">' +
          '<span>' + (e.descricao || 'Movimentação') + rotulo + '</span>' +
          '<strong>' + sinal + e.coins + '</strong>' +
          '</li>';
      }).join('');

      var aviso = '';
      if (d.proximoVencimento) {
        var venc = new Date(d.proximoVencimento);
        var dias = Math.ceil((venc - new Date()) / 86400000);
        if (dias > 0 && dias <= 30) {
          aviso = '<p class="coins-saldo__aviso">Seus coins mais antigos vencem em ' + dias + ' dia(s).</p>';
        }
      }

      root.innerHTML =
        '<div class="coins-saldo">' +
          '<span class="coins-saldo__label">Seu saldo</span>' +
          '<p class="coins-saldo__valor"><strong>' + d.coins + '</strong> coins ' +
            '<span class="coins-saldo__sep">=</span> <strong>' + d.valorFormatado + '</strong></p>' +
          (d.pendentes > 0
            ? '<p class="coins-saldo__pendente">' + d.pendentes + ' coins aguardando moderação (' + d.pendentesFormatado + ')</p>'
            : '') +
          aviso +
          '<p class="coins-saldo__regra">Resgate a partir de ' + d.regras.resgateMinimo +
            ' coins, de ' + d.regras.resgatePasso + ' em ' + d.regras.resgatePasso +
            ', até ' + d.regras.tetoPercentual + '% do subtotal do pedido.</p>' +
        '</div>' +
        (extrato ? '<ul class="coins-extrato">' + extrato + '</ul>' : '');
    });
  }

  document.querySelectorAll('[data-coins-balance]').forEach(initBalance);


  /* ============================================================
     C. Resgate no carrinho
  ============================================================ */
  function initRedeem(root) {
    var proxy = root.getAttribute('data-proxy') || '/apps/robusta-coins';
    var subtotal = parseInt(root.getAttribute('data-subtotal'), 10) || 0;
    var temCupom = root.getAttribute('data-has-discount') === 'true';

    var slider = root.querySelector('[data-coins-slider]');
    var out = root.querySelector('[data-coins-output]');
    var btn = root.querySelector('[data-coins-redeem]');
    var msg = root.querySelector('[data-coins-redeem-msg]');

    api(proxy, '/cotacao?subtotal=' + subtotal + '&cupom=' + (temCupom ? 1 : 0)).then(function (res) {
      var d = res.data || {};
      if (d.logado === false) { root.setAttribute('hidden', 'hidden'); return; }

      if (d.bloqueadoPorCupom) {
        root.innerHTML = '<p class="coins-redeem__bloqueado">Coins não somam com cupom de campanha. ' +
          'Remova o cupom para usar seus ' + d.coins + ' coins.</p>';
        return;
      }

      if (!d.maxCoins) {
        root.innerHTML = '<p class="coins-redeem__bloqueado">Você tem ' + d.coins + ' coins. ' +
          'O resgate começa em ' + d.minimo + ' coins e vale até ' + d.maxFormatado + ' neste carrinho.</p>';
        return;
      }

      root.removeAttribute('hidden');
      if (slider) {
        slider.min = String(d.minimo);
        slider.max = String(d.maxCoins);
        slider.step = String(d.passo);
        slider.value = String(d.maxCoins);
        atualizarSaida();
        slider.addEventListener('input', atualizarSaida);
      }

      function atualizarSaida() {
        var coins = parseInt(slider.value, 10);
        var valor = (coins * (d.maxCentavos / d.maxCoins)) / 100;
        if (out) out.textContent = coins + ' coins = R$ ' + valor.toFixed(2).replace('.', ',');
      }

      if (btn) {
        btn.addEventListener('click', function () {
          btn.disabled = true;
          api(proxy, '/resgate', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              coins: parseInt(slider.value, 10),
              subtotal: subtotal,
              cupom: temCupom,
            }),
          }).then(function (r) {
            btn.disabled = false;
            var dd = r.data || {};
            if (!r.ok) {
              if (msg) { msg.textContent = dd.mensagem || 'Não foi possível resgatar.'; msg.setAttribute('data-state', 'erro'); msg.removeAttribute('hidden'); }
              return;
            }
            // Aplica o cupom no carrinho e recarrega
            fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ discount: dd.cupom }),
            }).then(function () { window.location.reload(); });
          });
        });
      }
    });
  }

  document.querySelectorAll('[data-coins-redeem-widget]').forEach(initRedeem);

  /* ============================================================
     C. Vitrine de avaliações na página de produto

     A nota média já vem renderizada pelo servidor, vinda do metacampo.
     Aqui só buscamos a lista, que é o conteúdo pesado.
  ============================================================ */
  function escapar(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function estrelas(nota, classe) {
    var out = '<span class="' + classe + '" role="img" aria-label="' + nota + ' de 5">';
    for (var i = 1; i <= 5; i++) {
      out += '<svg viewBox="0 0 24 24" class="product-reviews__star' + (i <= nota ? ' is-on' : '') +
             '" aria-hidden="true"><path d="m12 2 3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
    }
    return out + '</span>';
  }

  function dataCurta(ms) {
    try {
      return new Date(Number(ms)).toLocaleDateString('pt-BR', {
        day: '2-digit', month: 'short', year: 'numeric',
      });
    } catch (e) { return ''; }
  }

  function initReviewsWidget(root) {
    var proxy = root.getAttribute('data-proxy') || '/apps/robusta-coins';
    var produto = root.getAttribute('data-product-id');
    var porPagina = Number(root.getAttribute('data-por-pagina') || 6);
    if (!produto) return;

    var lista = root.querySelector('[data-reviews-list]');
    var painel = root.querySelector('[data-reviews-panel]');
    var dist = root.querySelector('[data-reviews-dist]');
    var filtros = root.querySelector('[data-reviews-filters]');
    var tiras = root.querySelector('[data-reviews-photos]');
    var mais = root.querySelector('[data-reviews-more]');
    var status = root.querySelector('[data-reviews-status]');
    var exemplos = root.querySelector('[data-reviews-fallback]');

    var estado = { pagina: 1, nota: null, midia: false, agregado: null };
    // Todas as mídias já carregadas, na ordem da tela — é o que o visualizador navega.
    var galeria = [];

    function url() {
      var p = '/avaliacoes?produto=' + encodeURIComponent(produto) +
              '&limite=' + porPagina + '&pagina=' + estado.pagina;
      if (estado.nota) p += '&nota=' + estado.nota;
      if (estado.midia) p += '&midia=1';
      return p;
    }

    function desenharDistribuicao(ag) {
      if (!dist || !ag || !ag.total) return;
      var html = '';
      for (var n = 5; n >= 1; n--) {
        var qtd = ag.distribuicao[n] || 0;
        var pct = ag.total ? Math.round((qtd / ag.total) * 100) : 0;
        var ativo = estado.nota === n;
        html +=
          '<button type="button" class="reviews-dist__row' + (ativo ? ' is-on' : '') + '" data-nota="' + n + '"' +
          ' aria-pressed="' + (ativo ? 'true' : 'false') + '">' +
            '<span class="reviews-dist__label">' + n + '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 2 3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg></span>' +
            '<span class="reviews-dist__track"><span class="reviews-dist__fill" style="width:' + pct + '%"></span></span>' +
            '<span class="reviews-dist__n">' + qtd + '</span>' +
          '</button>';
      }
      dist.innerHTML = html;
    }

    function desenharFiltros(ag) {
      if (!filtros) return;
      var chips = [
        { rotulo: 'Todas', ativo: !estado.nota && !estado.midia, acao: 'todas' },
      ];
      if (ag && ag.comMidia > 0) {
        chips.push({
          rotulo: 'Com foto e vídeo (' + ag.comMidia + ')',
          ativo: estado.midia, acao: 'midia',
        });
      }
      filtros.innerHTML = chips.map(function (c) {
        return '<button type="button" class="reviews-chip' + (c.ativo ? ' is-on' : '') +
               '" data-acao="' + c.acao + '" aria-pressed="' + (c.ativo ? 'true' : 'false') + '">' +
               escapar(c.rotulo) + '</button>';
      }).join('');
    }

    function cartao(av) {
      var midias = [];
      (av.fotos || []).forEach(function (u) { midias.push({ tipo: 'foto', url: u }); });
      if (av.video) midias.push({ tipo: 'video', url: av.video });

      var thumbs = '';
      if (midias.length) {
        thumbs = '<div class="reviews-card__midia">' + midias.map(function (m) {
          var i = galeria.push(m) - 1;
          if (m.tipo === 'video') {
            return '<button type="button" class="reviews-thumb reviews-thumb--video" data-midia="' + i + '" aria-label="Ver vídeo da avaliação">' +
                   '<video src="' + escapar(m.url) + '" muted playsinline preload="metadata"></video>' +
                   '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg></button>';
          }
          return '<button type="button" class="reviews-thumb" data-midia="' + i + '" aria-label="Ampliar foto da avaliação">' +
                 '<img src="' + escapar(m.url) + '" alt="" loading="lazy"></button>';
        }).join('') + '</div>';
      }

      return '<article class="reviews-card">' +
        '<header class="reviews-card__top">' +
          estrelas(av.nota, 'reviews-card__stars') +
          '<time class="reviews-card__data">' + dataCurta(av.data) + '</time>' +
        '</header>' +
        (av.titulo ? '<h3 class="reviews-card__titulo">' + escapar(av.titulo) + '</h3>' : '') +
        (av.texto ? '<p class="reviews-card__texto">' + escapar(av.texto) + '</p>' : '') +
        thumbs +
        (av.doProprioProduto === false
          ? '<p class="reviews-card__origem">Avaliação do kit ' + escapar(av.origemTitulo || 'que inclui este produto') + '</p>'
          : '') +
        '<footer class="reviews-card__foot">' +
          '<span class="reviews-card__autor">' + escapar(av.autor) + '</span>' +
          (av.compraVerificada
            ? '<span class="reviews-card__selo"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>Compra verificada</span>'
            : '') +
        '</footer>' +
      '</article>';
    }

    function carregar(acrescentar) {
      if (status) { status.textContent = 'Carregando avaliações…'; status.removeAttribute('hidden'); }

      api(proxy, url()).then(function (r) {
        if (status) status.setAttribute('hidden', '');
        var d = (r && r.data) || {};
        var avs = d.avaliacoes || [];

        if (!acrescentar) { galeria = []; if (lista) lista.innerHTML = ''; }
        estado.agregado = estado.agregado || d;

        if (!avs.length && !acrescentar) {
          if (mais) mais.setAttribute('hidden', '');

          // Filtro sem resultado: a seção continua de pé, só a lista muda.
          if (estado.nota || estado.midia) {
            if (lista) lista.innerHTML = '<p class="reviews-vazio">Nenhuma avaliação com esse filtro.</p>';
            if (d.total) { desenharDistribuicao(d); desenharFiltros(d); if (painel) painel.removeAttribute('hidden'); }
            return;
          }

          /* Produto sem nenhuma avaliação. Tudo que existe só para organizar
             avaliação — painel, tira de fotos, lista, botão — some. Deixar
             esses recipientes vazios na tela criava caixas soltas e o botão
             de paginação colado no aviso. */
          if (painel) painel.setAttribute('hidden', '');
          if (tiras) tiras.setAttribute('hidden', '');
          if (lista) lista.innerHTML = '';
          root.classList.add('sem-avaliacoes');

          // Sem avaliação, a seção simplesmente não mostra lista. Os blocos
          // de exemplo do editor, se existirem, continuam valendo.
          if (exemplos) exemplos.removeAttribute('hidden');
          return;
        }

        root.classList.remove('sem-avaliacoes');

        if (exemplos) exemplos.setAttribute('hidden', '');

        if (lista) lista.insertAdjacentHTML('beforeend', avs.map(cartao).join(''));

        if (d.total) {
          desenharDistribuicao(d);
          desenharFiltros(d);
          if (painel) painel.removeAttribute('hidden');
        }

        if (mais) {
          if (d.temMais) mais.removeAttribute('hidden');
          else mais.setAttribute('hidden', '');
          // :has() cobre a maioria dos navegadores, mas não todos; a classe
          // garante o mesmo resultado onde ele não existe.
          var wrap = mais.parentElement;
          if (wrap) wrap.style.display = d.temMais ? '' : 'none';
        }

        desenharTira();
      }).catch(function () {
        if (status) {
          status.textContent = 'Não foi possível carregar as avaliações agora.';
          status.removeAttribute('hidden');
        }
      });
    }

    /* Tira de fotos no topo: só as imagens, para dar prova visual antes da leitura. */
    function desenharTira() {
      if (!tiras) return;
      var fotos = galeria.filter(function (m) { return m.tipo === 'foto'; }).slice(0, 12);
      if (fotos.length < 3) { tiras.setAttribute('hidden', ''); return; }
      tiras.innerHTML = fotos.map(function (m) {
        var i = galeria.indexOf(m);
        return '<button type="button" class="reviews-tira__item" data-midia="' + i + '" aria-label="Ampliar foto de cliente">' +
               '<img src="' + escapar(m.url) + '" alt="" loading="lazy"></button>';
      }).join('');
      tiras.removeAttribute('hidden');
    }

    /* ── Visualizador ── */
    var caixa = document.querySelector('[data-reviews-lightbox]');
    var palco = caixa && caixa.querySelector('[data-lightbox-stage]');
    var atual = 0;
    var focoAnterior = null;

    function mostrar(i) {
      if (!caixa || !palco || !galeria.length) return;
      atual = (i + galeria.length) % galeria.length;
      var m = galeria[atual];
      palco.innerHTML = m.tipo === 'video'
        ? '<video src="' + escapar(m.url) + '" controls autoplay playsinline></video>'
        : '<img src="' + escapar(m.url) + '" alt="Foto enviada por cliente">';
    }

    function abrir(i) {
      if (!caixa) return;
      focoAnterior = document.activeElement;
      mostrar(i);
      caixa.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      var fechar = caixa.querySelector('[data-lightbox-close]');
      if (fechar) fechar.focus();
    }

    function fechar() {
      if (!caixa) return;
      caixa.setAttribute('hidden', '');
      if (palco) palco.innerHTML = '';
      document.body.style.overflow = '';
      if (focoAnterior && focoAnterior.focus) focoAnterior.focus();
    }

    if (caixa && !caixa.hasAttribute('data-ligado')) {
      caixa.setAttribute('data-ligado', '1');
      var bFechar = caixa.querySelector('[data-lightbox-close]');
      var bPrev = caixa.querySelector('[data-lightbox-prev]');
      var bNext = caixa.querySelector('[data-lightbox-next]');
      if (bFechar) bFechar.addEventListener('click', fechar);
      if (bPrev) bPrev.addEventListener('click', function () { mostrar(atual - 1); });
      if (bNext) bNext.addEventListener('click', function () { mostrar(atual + 1); });
      caixa.addEventListener('click', function (e) { if (e.target === caixa) fechar(); });
      document.addEventListener('keydown', function (e) {
        if (caixa.hasAttribute('hidden')) return;
        if (e.key === 'Escape') fechar();
        if (e.key === 'ArrowLeft') mostrar(atual - 1);
        if (e.key === 'ArrowRight') mostrar(atual + 1);
      });
    }

    /* ── Interações ── */
    root.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-midia]');
      if (thumb) { abrir(Number(thumb.getAttribute('data-midia'))); return; }

      var linha = e.target.closest('[data-nota]');
      if (linha) {
        var n = Number(linha.getAttribute('data-nota'));
        estado.nota = estado.nota === n ? null : n;
        estado.midia = false;
        estado.pagina = 1;
        carregar(false);
        return;
      }

      var chip = e.target.closest('[data-acao]');
      if (chip) {
        var acao = chip.getAttribute('data-acao');
        estado.nota = null;
        estado.midia = acao === 'midia';
        estado.pagina = 1;
        carregar(false);
      }
    });

    if (mais) {
      mais.addEventListener('click', function () {
        estado.pagina += 1;
        carregar(true);
      });
    }

    carregar(false);
  }

  document.querySelectorAll('[data-reviews-widget]').forEach(initReviewsWidget);

  /* ============================================================
     D. Área do Robusta Coins na conta do cliente
  ============================================================ */
  function initCoinsArea(root) {
    var proxy = root.getAttribute('data-proxy') || '/apps/robusta-coins';
    var saldoEl = root.querySelector('[data-coins-area-saldo]');
    var blocoEl = root.querySelector('[data-coins-area-avaliaveis]');
    var filaEl = root.querySelector('[data-coins-fila]');
    var hintEl = root.querySelector('[data-coins-area-hint]');
    var formEl = root.querySelector('[data-coins-area-form]');
    var voltarEl = root.querySelector('[data-coins-area-voltar]');
    var extratoEl = root.querySelector('[data-coins-area-extrato]');
    var lancEl = root.querySelector('[data-coins-area-lancamentos]');
    var formulario = root.querySelector('[data-coins-review]');
    var itens = [];

    api(proxy, '/saldo').then(function (res) {
      var d = (res && res.data) || {};
      if (!saldoEl) return;

      if (d.logado === false) {
        saldoEl.innerHTML = '<p>Entre na sua conta para ver seus coins.</p>';
        return;
      }

      saldoEl.innerHTML =
        '<div class="coins-saldo__linha">' +
          '<strong class="coins-saldo__num">' + (d.coins || 0) + '</strong>' +
          '<span class="coins-saldo__moeda">coins</span>' +
          '<span class="coins-saldo__valor">' + (d.valorFormatado || 'R$ 0,00') + '</span>' +
        '</div>' +
        (d.pendentes ? '<p class="coins-saldo__pend">' + d.pendentes +
          ' coins aguardando moderação. Liberamos em até 72h.</p>' : '') +
        (d.proximoVencimento ? '<p class="coins-saldo__venc">Primeiro vencimento em ' +
          new Date(d.proximoVencimento).toLocaleDateString('pt-BR') + '.</p>' : '');

      var ext = d.extrato || [];
      if (ext.length && lancEl && extratoEl) {
        lancEl.innerHTML = ext.map(function (l) {
          var sinal = l.coins > 0 ? '+' : '';
          return '<li><span>' + escapar(l.descricao || l.tipo || 'Lançamento') + '</span>' +
                 '<strong>' + sinal + l.coins + '</strong></li>';
        }).join('');
        extratoEl.removeAttribute('hidden');
      }
    });

    api(proxy, '/avaliaveis').then(function (res) {
      var d = (res && res.data) || {};
      itens = d.itens || [];
      if (!blocoEl || !filaEl) return;

      if (!itens.length) {
        blocoEl.removeAttribute('hidden');
        filaEl.innerHTML = '<li class="coins-fila__vazio">Nada para avaliar agora. ' +
          'A avaliação abre 7 dias depois da entrega e fica aberta por 60 dias.</li>';
        return;
      }

      if (hintEl && d.maximoFormatado) {
        hintEl.textContent = 'Cada avaliação completa vale até ' + d.maximoPorAvaliacao +
          ' coins, o equivalente a ' + d.maximoFormatado + ' de desconto.';
      }

      filaEl.innerHTML = itens.map(function (it, i) {
        var foto = it.imagem
          ? '<img src="' + escapar(it.imagem) + '" alt="" loading="lazy">'
          : '<span class="coins-fila__sem-foto" aria-hidden="true"></span>';
        var prazo = it.fecha <= 7
          ? '<span class="coins-fila__prazo coins-fila__prazo--urgente">Fecha em ' + it.fecha + ' dia' + (it.fecha === 1 ? '' : 's') + '</span>'
          : '<span class="coins-fila__prazo">Fecha em ' + it.fecha + ' dias</span>';
        return '<li class="coins-fila__item">' + foto +
          '<div class="coins-fila__info"><strong>' + escapar(it.titulo) + '</strong>' + prazo + '</div>' +
          '<button type="button" class="coins-fila__btn" data-avaliar="' + i + '">Avaliar</button></li>';
      }).join('');
      blocoEl.removeAttribute('hidden');
    });

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-avaliar]');
      if (!btn || !formulario || !formulario.abrirPara) return;
      formulario.abrirPara(itens[Number(btn.getAttribute('data-avaliar'))]);
      if (blocoEl) blocoEl.setAttribute('hidden', '');
      if (formEl) formEl.removeAttribute('hidden');
      formEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    if (voltarEl) {
      voltarEl.addEventListener('click', function () {
        if (formEl) formEl.setAttribute('hidden', '');
        if (blocoEl) blocoEl.removeAttribute('hidden');
      });
    }
  }

  document.querySelectorAll('[data-coins-area]').forEach(initCoinsArea);
})();
